export const LIST = {
  name: 'highlights',
  path: '/sites/:siteId/highlights/:collectionId',
};
